module.exports = __webpack_public_path__ + "img/calendar.50cdcf3c.svg";